import { call, put, select } from 'redux-saga/effects';
import { refreshBetsSaga } from './refreshBetsSaga';
import { isTheLast2SecondsInBettingTimeSelector } from '../../BettingTime';
import { roundStateSelector } from '../../RoundStates';
import { IRoundState, RoundStates } from '../../RoundStates/types';
import { clearDoubleBetAction } from '../../BetDouble/actions';
import { clearRepeatBetAction } from '../../BetRepeat/actions';
import { ICreatePendingBetRequestData, RestService } from 'services/RestAPIService';
import { setTotalBetAction } from '../../User/actions';
import * as Sentry from '@sentry/react';
import { refreshBetsAction } from '../actions';

export function* cancelAllBetsSaga() {
  const isTheLast2SecondsInBettingTime: boolean = yield select(
    isTheLast2SecondsInBettingTimeSelector,
  );
  const roundState: IRoundState['roundState'] = yield select(roundStateSelector);

  if (!isTheLast2SecondsInBettingTime) {
    yield refreshBetsSaga({
      past: [],
      present: [],
      future: [],
    });
    yield put(clearDoubleBetAction());
    yield put(clearRepeatBetAction());
  }

  if (isTheLast2SecondsInBettingTime) {
    if (roundState === RoundStates.BettingTimeStarted) {
      const betsData: ICreatePendingBetRequestData = {
        bets: [],
        info: [],
        timeStamp: new Date().getTime(),
      };

      try {
        const response: ICreatePendingBetRequestData = yield call(() =>
          RestService.createPendingBet(betsData),
        );

        yield put(setTotalBetAction(0));
        yield put(
          refreshBetsAction({
            past: [],
            present: {},
            future: [],
          }),
        );
      } catch (error) {
        Sentry.captureException({ error, betsData });
        console.log(error);
      }
    }
  }
}
